import { IButton } from "types/gaiaComponents/button";
import React from "react";
import { Tooltip } from "components/tooltip/Tooltip";
import { SHARED_TOOLTIP_ID } from "components/tooltip/AppTooltip.component";


export const ButtonType = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    GHOST: "ghost",
    TRANSPARENT: "transparent",
}
export const Button = React.forwardRef((props: IButton, ref) => {
    // When a `tooltip` is provided, the button becomes the trigger: `data-for` points at the
    // shared tooltip instance and `data-tip` names this button's own tooltip, whose content the
    // sibling <Tooltip> registers. Callers don't need to wrap the button themselves, and `title`
    // still works for a plain native tooltip.
    const hasTooltip = !!(props.tooltip?.id && props.tooltip?.content);
    const button = (
        <button className={`ga-button ga-button--${props.type}${props.iconOnly ? " ga-button--icon-only" : ""}${props.extraClassName? " "+props.extraClassName: ""}`}
                id={props.id}
                type={"button"}
                //@ts-ignore
                ref={ref}
                disabled={props.disabled}
                onClick={props.onClick}
                onBlur={props.onBlur}
                title={props.title}
                tabIndex={props.tabIndex}
                data-cy={props.dataCy}
                data-testid={props.dataTestId}
                data-target={props.dataTarget}
                data-toggle={props.dataToggle}
                data-for={SHARED_TOOLTIP_ID} data-place={hasTooltip ? props.tooltip!.place : undefined}
                data-tip={hasTooltip ? props.tooltip!.id : undefined}
                aria-label={props.ariaLabel}
                aria-expanded={props.ariaExpanded}
                aria-controls={props.ariaControls}>
            {props.icon}
            {props.text}
            {props.rightIcon}
        </button>
    );

    if (!hasTooltip) {
        return button;
    }

    return (
        <>
            {button}
            <Tooltip
                id={props.tooltip!.id}
                content={props.tooltip!.content}
            />
        </>
    );
});